import FeesIcon from '~/assets/icons/Fees';
import PaymentIcon from '~/assets/icons/Payment';
import UserIcon from '~/assets/icons/User';
import Image from '~/components/Image';
import Tracked from '~/components/Tracked';
import useEnv from '~/hooks/useEnv';

const buttonData = [
  { className: 'col-span-2', icon: <UserIcon />, text: 'Millions of users' },
  { className: 'col-span-2', icon: <PaymentIcon />, text: 'Fast payment' },
  {
    className: 'col-span-2 col-start-2 col-end-4',
    icon: <FeesIcon />,
    text: 'Low reseller fees'
  }
];

const SoleMarketSignUpBanner = () => {
  const env = useEnv();

  return (
    <div className="relative bg-dark-background text-white">
      <Image
        alt="sole-market-hub-sign-up-banner"
        src="https://cms-cdn.thesolesupplier.co.uk/banners/sole_market_sign_up_banner.jpeg"
        className="absolute left-0 top-0 size-full object-cover"
        loading="lazy"
        width={672}
        quality={100}
        responsiveOptions={{
          lg: { width: 1024 },
          md: { width: 768 },
          sm: { width: 672 },
          xl: { width: 1440 }
        }}
      />
      <div className="relative mx-auto flex max-w-desktop flex-col gap-2 p-4 md:px-8 lg:py-8 desktop:px-0">
        <p className="text-center lg:w-1/2 lg:text-left">
          Sell sneakers effortlessly on our marketplace and benefit from fast
          payments and low fees (just 6%). Join now to connect with our
          community.
        </p>
        <div className="flex flex-col gap-2 lg:flex lg:flex-row lg:items-center lg:justify-between">
          <div className="grid grid-cols-4 gap-2 lg:flex">
            {buttonData.map(({ text, icon, className }, index) => (
              <div
                className={`${className} flex h-12 items-center justify-center gap-2 rounded-lg bg-gray-100/30 p-2 lg:px-4`}
                key={index}
              >
                {icon}
                {text}
              </div>
            ))}
          </div>
          <a
            href={`${env.SITE_BASE_URL}/marketplace/sell/register/`}
            target="_blank"
            rel="noreferrer"
          >
            <Tracked.Button
              className="lg:w-72"
              variant="green-human"
              data-cy="register-as-seller-button"
              name="REGISTER_AS_A_SELLER"
              pagePosition="Banner"
            >
              Register as a seller
            </Tracked.Button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default SoleMarketSignUpBanner;
